import styled, { css } from 'styled-components'

import { PlayIcon } from '@nx/fire/assets'
import {
  FireCarousel,
  StyledArrowButton,
  StyledPaginationBlock,
} from '@nx/fire/carousel'
import { FireImage } from '@nx/fire/image'
import { Body } from '@nx/fire/typography'

export const SingleImageButton = styled.button`
  background-color: ${({ theme }) => theme.colours.primary.white};
  padding: 0;
  border: none;
  width: 100%;
  cursor: zoom-in;
  display: flex;
  justify-content: center;

  img {
    width: 100%;
    height: 330px;
    display: block;
    object-fit: contain;

    ${({ theme }) => theme.media.up.md} {
      height: 430px;
    }
  }
`

export const ThumbImage = styled.img`
  width: 100%;
  height: 100px;
  display: block;
  object-fit: contain;
  background-color: ${({ theme }) => theme.colours.primary.white};
`

export const StyledVideoContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`

export const StyledGreyOverlay = styled.div`
  background-color: rgb(0 0 0 / 30%);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`

export const StyledPlayedIcon = styled(PlayIcon)`
  ${({ theme }) => css`
    color: ${theme.colours.primary.white};
    border: 3px solid ${theme.colours.primary.white};
    border-radius: 100%;
    height: 36px;
    left: 50%;
    padding: 6px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 36px;
  `}
`

export const ThumbnailCaption = styled(Body)`
  color: ${({ theme }) => theme.colours.primary.charcoal};
  font-size: 10px;
  line-height: 1.2;
  font-style: italic;
  display: block;
  text-align: left;
  margin-top: 5px;
`

export const StyledImageContainer = styled.div`
  background-color: ${({ theme }) => theme.colours.primary.white};
  display: flex;
  justify-content: center;
  cursor: zoom-in;

  img {
    width: 100%;
    height: 330px;
    display: block;
    object-fit: contain;

    ${({ theme }) => theme.media.up.md} {
      height: 430px;
    }
  }
`

export const StyledMainCarouselContainer = styled.div`
  ${StyledPaginationBlock} {
    display: grid;
    background: white;
    margin-top: 0;
    grid-template-columns: 1fr;

    ${StyledArrowButton} {
      display: none;
    }
  }

  ${({ theme }) => theme.media.up.md} {
    ${StyledPaginationBlock} {
      display: none;
    }
  }
`

export const StyledThumbnailCarouselContainer = styled.div<{
  $withCaption: boolean
}>`
  display: none;

  ${({ theme }) => theme.media.up.md} {
    display: block;

    --gap: 12px;

    margin-top: 1rem;
    z-index: 1;

    ${StyledPaginationBlock} {
      z-index: 0;
      position: relative;
      top: ${({ $withCaption }) => ($withCaption ? '-5.5rem' : '-4.5rem')};
      margin: auto;
    }
  }
`

export const StyledThumbnailCarousel = styled(FireCarousel)<{
  $showThumbnailArrows: boolean
}>`
  width: ${({ $showThumbnailArrows }) =>
    $showThumbnailArrows ? '87%' : '100%'};
  margin: auto;
  position: relative;
  z-index: 1;
`

export const StyledThumbnailImage = styled(FireImage)`
  width: 110px;
  height: 100px;
  object-fit: contain;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colours.primary.white};
`

export const StyledImageButton = styled.button<{ $thumbnailIndex: number }>`
  border: 1px solid;
  border-color: var(
    ${({ $thumbnailIndex }) =>
      `--activeThumbnail${$thumbnailIndex}BorderColor`},
    transparent
  );
  outline: none;
  padding: 0;
  margin: 0;
  position: relative;
  background: none;
`
